import { useSelector } from "react-redux";
import React from 'react';

import useStyles from "./styles";
import CustomDashletChart from "../CustomDashletChart";
import { Typography, Grid } from '@material-ui/core';
import { pathOr } from "ramda";

export default function CustomDashletCompare({ data, fullData }) {
	// const { currentTheme } = useSelector((state) => state.config.themeConfig);
	// const classes = useStyles();

	const showCharts = (data) => {

		let charts = pathOr([], ['data', 'charts'], data)
		
		return charts.map((chart, chartRow) => {
			let result = pathOr([], ['result', chartRow], fullData);
			// console.log("Chart====",chart,result)
		
			return <Grid key={chart.name} item xs={6}>

				<Typography style={{ textAlign: 'center' }} variant="subtitle2" component="div">
					{chart.title}
				</Typography>
				<CustomDashletChart key={chart.name} data={chart} fullData={fullData} result={result} />
			</Grid>
		})

	}

	return <Grid
		container
		direction="row"
		justify="center"
		alignItems="center"
	// spacing={3}
	>
		{showCharts(data)}</Grid>;

}

